import styled from 'styled-components/macro';
import { Title as BaseTitle } from '../../ui/texts';

const Title = styled(BaseTitle)`
  font-size: 24px;
`;

export default Title;
